// Shared helpers for comparing "from" prices across ticket sellers.
export function priceNumber(link) {
    const m = (link?.starting_from || "").match(/[\d,]+\.?\d*/);
    if (!m) return null;
    const v = parseFloat(m[0].replace(/,/g, ""));
    return Number.isNaN(v) ? null : v;
  }
  
  // The lowest "from" price, only when at least two sellers list one.
  export function cheapestPrice(links) {
    const prices = (links || []).map(priceNumber).filter((p) => p !== null);
    return prices.length > 1 ? Math.min(...prices) : null;
  }
  
  export function isCheapestLink(link, cheapest) {
    return cheapest !== null && priceNumber(link) === cheapest;
  }

  
// True only when every seller has a 'from' price, so "Cheapest" is a fair claim.
export function allPriced(links) {
    return (links || []).length > 0 && (links || []).every((l) => priceNumber(l) !== null);
  }